import React, { useEffect } from "react";
import "./orders.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import Datatable from "../../components/datatable/Datatable";

function Orders() {
  useEffect(() => {
    document.title = "Wishallbook >> Orders";
  }, []);

 /* const hanldeclick = async () => {
    const museums = query(collectionGroup(db, "Library"));
    const querySnapshot = await getDocs(museums);
    const totalvalue = querySnapshot.size;
    var completedValue = 0;
    querySnapshot.forEach(async (docs) => {
      const libId = docs.id;
      const userUid = docs.ref.parent.parent.id;
      const payment_UID = docs.data().payment_UID;
      const paymentRef = doc(db, "Users", userUid, "Payments", payment_UID);
      const paymentSnap = await getDoc(paymentRef);
      const bookref = doc(db, "Users", userUid, "Library", libId);
      await updateDoc(bookref, {
        timestamp: paymentSnap.data().timestamp,
      });
      completedValue++;
      console.log(completedValue + "/" + totalvalue);
    });
  };*/

  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
       
        <Datatable type="orders"/>
      </div>
    </div>
  );
}

export default Orders;
